var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/core-js/library/modules/_has.js
// module id = 92
// module chunks = 0